// eslint-disable-next-line no-restricted-imports
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useCallback } from 'react';

import { LDFlagValueTypes, LDFlags } from '../constants/flags';
import { evaluateFlag } from './useFlag';

/**
 * Returns a function that evaluates a LaunchDarkly flag *when you call it*.
 * Use this when you only want to enroll a user into an experiment after a certain condition is met
 */
export const useLazyFlag = () => {
  const ldClient = useLDClient();

  return useCallback(
    <T extends LDFlags>(flag: T, shouldTrack = true): LDFlagValueTypes[T] =>
      evaluateFlag(ldClient, flag, shouldTrack),
    [ldClient],
  );
};
